const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ components
const MortgageRequestManageAppraiserVisit = require('../mortgageRequestManageAppraiserVisit/mortgageRequestManageAppraiserVisit');
const MortgageRequestAppraisalSetAccount = require('./mortgageRequestAppraisalSetAccount');
const { PEND_TASACION } = require('constants/mortgageRequestStates');

const MortgageRequestAppraisalRequestStep2 = props => {
    const {
        getBlockedAccounts,
        immAppraisalRequest,
        immAccounts,
        immEstates,
        resetBlockedAccounts,
        setAccount,
        setTotalCost,
        immPayment,
        immState,
        history
    } = props;

        const currentState = immState.get('estado');
        const appraisalStateFlag = currentState !== PEND_TASACION;
        if(appraisalStateFlag){
            history.push('/myprofile/mortgage/property-value');
        }

    return (
        <div className="mortgage-request-appraisal-request-step-two">
            <MortgageRequestAppraisalSetAccount
                getBlockedAccounts={getBlockedAccounts}
                immAppraisalRequest={immAppraisalRequest}
                immAccounts={immAccounts}
                immEstates={immEstates}
                resetBlockedAccounts={resetBlockedAccounts}
                setAccount={setAccount}
                setTotalCost={setTotalCost}
                immPayment={immPayment}
            />
            <MortgageRequestManageAppraiserVisit />
        </div>
    );
};

MortgageRequestAppraisalRequestStep2.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setTotalCost: PropTypes.func.isRequired,
    immState: PropTypes.object.isRequired,
    history: PropTypes.object,
};

module.exports = withRouter(MortgageRequestAppraisalRequestStep2);
